import {parseDMY} from './parseDMY'

const MS_PER_DAY = 1000 * 60 * 60 * 24

export function getOldestUnpaidDaysPastDue(rows: any[]): number | null {
  const unpaid = rows.filter((row) => !row.paid_date && row.due_date)
  if (unpaid.length === 0) {
    return null
  }
  unpaid.sort((a, b) => {
    const dateA = parseDMY(a.due_date)
    const dateB = parseDMY(b.due_date)
    if (!dateA || !dateB) {
      return 0
    }
    return dateA.getTime() - dateB.getTime()
  })
  const oldestDue = parseDMY(unpaid[0].due_date)
  if (!oldestDue) {
    return null
  }
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  oldestDue.setHours(0, 0, 0, 0)
  return Math.floor((today.getTime() - oldestDue.getTime()) / MS_PER_DAY)
}
